import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 transition-colors duration-200">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="mx-auto h-32 w-32 rounded-full bg-green-100 dark:bg-green-900 flex items-center justify-center mb-6">
            <span className="text-6xl font-bold text-green-500">404</span>
          </div>
        </div>
        
        <h1 className="text-4xl font-extrabold text-gray-900 dark:text-white mb-4">
          Página no encontrada
        </h1>
        
        <p className="text-lg text-gray-600 dark:text-gray-300 mb-8">
          La página que buscas no existe o ha sido movida. Puede que hayas seguido un enlace roto o ingresado una URL incorrecta.
        </p>
        
        <div className="space-y-4">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors duration-200"
          >
            <Home size={20} className="mr-2" />
            Volver al Inicio
          </Link>
          
          <div className="text-center">
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center text-green-600 hover:text-green-500 dark:text-green-400 dark:hover:text-green-300 font-medium transition-colors duration-200"
            >
              <ArrowLeft size={16} className="mr-1" />
              Volver atrás
            </button>
          </div>
        </div>
        
        <div className="mt-12 p-6 bg-white dark:bg-gray-800 rounded-lg shadow">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
            Enlaces útiles
          </h3>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <Link to="/login" className="text-green-600 hover:text-green-500 dark:text-green-400 dark:hover:text-green-300">
              Iniciar Sesión
            </Link>
            <Link to="/register" className="text-green-600 hover:text-green-500 dark:text-green-400 dark:hover:text-green-300">
              Registrarse
            </Link>
            <Link to="/athletes" className="text-green-600 hover:text-green-500 dark:text-green-400 dark:hover:text-green-300">
              Atletas
            </Link>
            <Link to="/marketplace" className="text-green-600 hover:text-green-500 dark:text-green-400 dark:hover:text-green-300">
              Marketplace
            </Link>
            <Link to="/about" className="text-green-600 hover:text-green-500 dark:text-green-400 dark:hover:text-green-300">
              Acerca de
            </Link>
            <Link to="/contact" className="text-green-600 hover:text-green-500 dark:text-green-400 dark:hover:text-green-300">
              Contacto
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;